// Contact.jsx
import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: ""
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Show success message immediately
    setIsSubmitted(true);
    
    // Reset form after 5 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: "",
        email: "",
        phone: "",
        service: "",
        message: ""
      });
    }, 5000);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-container">
        {/* Section Header */}
        <div className="contact-header">
          <span className="contact-tag">Contact Us</span>
          <h2 className="contact-title">
            Get In <span>Touch</span>
          </h2>
          <p className="contact-subtitle">
            Have questions or want to book our services? Reach out to us anytime.
            We're here to make your event special.
          </p>
        </div>

        {/* Contact Content */}
        <div className="contact-content">
          {/* Left Column - Contact Info */}
          <div className="contact-info">
            <div className="contact-info-card">
              <div className="contact-info-item">
                <div className="contact-icon">
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div className="contact-details">
                  <h4>Call Us</h4>
                  <p>
                    <a href="tel:7023332099">7023332099</a>
                  </p>
                  <span>Available 24/7</span>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <i className="fab fa-whatsapp"></i>
                </div>
                <div className="contact-details">
                  <h4>WhatsApp</h4>
                  <p>
                    <a href="https://wa.me/917023332099" target="_blank" rel="noopener noreferrer">
                      7023332099
                    </a>
                  </p>
                  <span>Chat with us instantly</span>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="contact-details">
                  <h4>Visit Us</h4>
                  <p>
                    720/5, Patel Nagar,<br />
                    Gurugram, Haryana 122001
                  </p>
                  <span>In front of Badha Hanuman Mandir</span>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <i className="fas fa-clock"></i>
                </div>
                <div className="contact-details">
                  <h4>Working Hours</h4>
                  <p>Open 24/7</p>
                  <span>Monday to Sunday</span>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="contact-details">
                  <h4>Email Us</h4>
                  <p>
                    <a href="mailto:info@atozevents.in">info@atozevents.in</a>
                  </p>
                  <span>We'll respond within 24 hours</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact-form-wrapper">
            <div className="contact-form-card">
              <h3>Send Us a Message</h3>
              <p>We'll get back to you as soon as possible</p>

              {isSubmitted ? (
                // Success Message
                <div className="contact-success">
                  <div className="success-icon">
                    <i className="fas fa-check-circle"></i>
                  </div>
                  <h4>Thank You!</h4>
                  <p>Your message has been sent successfully. We'll get back to you shortly.</p>
                  <button 
                    className="contact-submit-btn" 
                    onClick={() => {
                      setIsSubmitted(false);
                      setFormData({
                        name: "",
                        email: "",
                        phone: "",
                        service: "",
                        message: ""
                      });
                    }}
                  >
                    <i className="fas fa-plus"></i> Send Another Message
                  </button>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="name">Your Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter your full name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="service">Service Interested In</label>
                    <select id="service" name="service" value={formData.service} onChange={handleChange}>
                      <option value="">Select a service</option>
                      <option value="wedding">Wedding Decoration</option>
                      <option value="home">Home Decoration</option>
                      <option value="haldi">Haldi Decoration</option>
                      <option value="mehndi">Mehndi Decoration</option>
                      <option value="birthday">Birthday Decoration</option>
                      <option value="anniversary">Anniversary Decoration</option>
                      <option value="corporate">Corporate Event</option>
                      <option value="baby-shower">Baby Shower</option>
                      <option value="engagement">Engagement Decoration</option>
                      <option value="stage">Stage Decoration</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="message">Your Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="4"
                      placeholder="Tell us about your event and requirements..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button type="submit" className="contact-submit-btn">
                    <i className="fas fa-paper-plane"></i> Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Quick Action Buttons */}
        <div className="contact-quick-actions">
          <a href="tel:7023332099" className="quick-action-btn call-btn">
            <i className="fas fa-phone"></i>
            <span>Call Now</span>
          </a>
          <a href="https://wa.me/917023332099" target="_blank" rel="noopener noreferrer" className="quick-action-btn whatsapp-btn">
            <i className="fab fa-whatsapp"></i>
            <span>WhatsApp</span>
          </a>
          <a href="mailto:info@atozevents.in" className="quick-action-btn email-btn">
            <i className="fas fa-envelope"></i>
            <span>Email</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;